var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "view-form",
      attrs: { "label-width": "80px", "label-position": "top" },
    },
    _vm._l(_vm.tempFields, function (field) {
      return _c(
        "div",
        { key: field.value },
        [
          _c(
            "el-form-item",
            { staticClass: "ml15" },
            [
              _c("template", { slot: "label" }, [
                _c("label", { staticClass: "field-label" }, [
                  _vm._v(_vm._s(field.label)),
                ]),
              ]),
              field.type === "SORT"
                ? _c("div", [
                    _vm.pageFormModel[field.value]
                      ? _c(
                          "div",
                          _vm._l(
                            _vm.pageFormModel[field.value],
                            function (sort) {
                              return _c("text-copy", {
                                key: sort.value,
                                staticClass: "mb5",
                                attrs: { text: sort.label },
                              })
                            }
                          ),
                          1
                        )
                      : _vm._e(),
                  ])
                : field.type === "UPLOAD"
                ? _c("div", [
                    _vm.pageFormModel[field.value]
                      ? _c(
                          "div",
                          [
                            _c("file-list", {
                              attrs: { files: _vm.pageFormModel[field.value] },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : field.type === "IMAGE_UPLOAD"
                ? _c("div", [
                    _vm.pageFormModel[field.value]
                      ? _c(
                          "div",
                          [
                            _c("img-list", {
                              attrs: {
                                "image-list": _vm.pageFormModel[field.value],
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : field.type === "SIGN_PAD"
                ? _c("div", [
                    _vm.pageFormModel[field.value]
                      ? _c(
                          "div",
                          [
                            _c("img-list", {
                              attrs: {
                                "image-list": [
                                  { url: _vm.pageFormModel[field.value] },
                                ],
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : field.type === "USER_SELECT" || field.type === "DEPT_SELECT"
                ? _c("div", [
                    _vm.pageFormModel[field.value]
                      ? _c(
                          "div",
                          [
                            _c("text-copy", {
                              attrs: {
                                text: _vm.formatEmpValue(
                                  _vm.pageFormModel[field.value]
                                ),
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : field.type === "MATRIX_INPUT" ||
                  field.type === "MATRIX_SELECT" ||
                  field.type === "MATRIX_SCALE"
                ? _c("div", [
                    _vm.pageFormModel[field.value]
                      ? _c(
                          "div",
                          [
                            _c("matrix-view", {
                              attrs: {
                                "is-print": _vm.isPrint,
                                "matrix-layout": field.scheme.table,
                                value: _vm.pageFormModel[field.value],
                                type: field.type,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : field.type === "GOODS_SELECT"
                ? _c("div", [
                    _vm.pageFormModel[field.value]
                      ? _c(
                          "div",
                          [
                            _c("text-copy", {
                              attrs: {
                                text: _vm.formatGoodsValue(
                                  _vm.pageFormModel[field.value],
                                  field.scheme
                                ),
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : field.type === "RESERVE_DAY"
                ? _c("div", [
                    _vm.pageFormModel[field.value]
                      ? _c(
                          "div",
                          [
                            _c("text-copy", {
                              attrs: {
                                text: _vm.formatReserveValue(
                                  _vm.pageFormModel[field.value],
                                  field.scheme
                                ),
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : field.type === "RESERVE_TIME_RANGE"
                ? _c("div", [
                    _vm.pageFormModel[field.value]
                      ? _c(
                          "div",
                          [
                            _c("text-copy", {
                              attrs: {
                                text: _vm.formatReserveTimeValue(
                                  _vm.pageFormModel[field.value],
                                  field.scheme
                                ),
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : field.type === "SUB_FORM"
                ? _c("div", [
                    _vm.pageFormModel[field.value]
                      ? _c(
                          "div",
                          [
                            _c("sub-form-view", {
                              attrs: {
                                model: _vm.pageFormModel[field.value],
                                fields: field.scheme.childList,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : field.type === "PROVINCE_CITY"
                ? _c("div", [
                    _vm.pageFormModel[field.value]
                      ? _c(
                          "div",
                          [
                            _c("text-copy", {
                              attrs: {
                                text: _vm.formatProvinceValue(
                                  _vm.pageFormModel[field.value],
                                  field.scheme
                                ),
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _c(
                    "div",
                    { staticClass: "form-item-content" },
                    [
                      _c("text-copy", {
                        attrs: {
                          text: _vm.formatValue(_vm.pageFormModel[field.value]),
                        },
                      }),
                    ],
                    1
                  ),
            ],
            2
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }